import { render, staticRenderFns } from "./topR.vue?vue&type=template&id=6d2515e7&scoped=true"
import script from "./topR.vue?vue&type=script&lang=js"
export * from "./topR.vue?vue&type=script&lang=js"
import style0 from "./topR.vue?vue&type=style&index=0&id=6d2515e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2515e7",
  null
  
)

export default component.exports